"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicDataChangeCheck = exports.basicPropDiffing = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var simpleTypeDistill = function simpleTypeDistill(typeProp) {
  if (typeProp && typeProp.type) {
    return typeProp.type;
  }

  return typeProp;
};

var basicPropDiffing = function basicPropDiffing(previousProp, nextProp) {
  return simpleTypeDistill(previousProp) !== simpleTypeDistill(nextProp);
};

exports.basicPropDiffing = basicPropDiffing;

var basicDataChangeCheck = function basicDataChangeCheck(prevData, newData) {
  return prevData !== newData || Array.isArray(prevData) && Array.isArray(newData) && !!prevData.find(function (p) {
    return newData.indexOf(p) === -1;
  });
};

exports.basicDataChangeCheck = basicDataChangeCheck;


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/processing/diffing.js
// module id = 1082
// module chunks = 0